// actions.js

import { FETCH_LEAD_STATUS_FAILURE, FETCH_LEAD_STATUS_REQUEST, FETCH_LEAD_STATUS_SUCCESS } from "./actionType"

export const fetchLeadStatusRequest = () => ({
    type: FETCH_LEAD_STATUS_REQUEST
})

export const fetchLeadStatusSuccess = (statusOptions) => ({
    type: FETCH_LEAD_STATUS_SUCCESS,
    payload: statusOptions
})

export const fetchLeadStatusFailure = (error) => ({
    type: FETCH_LEAD_STATUS_FAILURE,
    payload: error
})

